import React, { useState } from 'react';
import { cfLogo } from '../../assets';
import { setCookie } from '../../helper';
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      // Fetch admin credentials from server for the provided email
      const resp = await fetch(`https://server.causalfunnels.com/api/admin/credentials?email=${encodeURIComponent(email)}`);
      if (!resp.ok) throw new Error('Network error');
      const result = await resp.json();
      const admin = result?.admin;
      if (result?.success && admin && admin.email === email && admin.password === password) {
        // mark as admin in session and set cookie
        sessionStorage.setItem('userType', 'admin');
        setCookie('user', 'causalfunnel-prod@causalfunnel.com', 3);
        navigate('/');
      } else {
        setError('Invalid admin credentials');
      }
    } catch (err) {
      console.error('Admin login error', err);
      setError('Failed to verify admin credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="login__page min-h-screen bg-neutral-200 dark:bg-neutral-700 flex items-center justify-center">
      <div className="container p-4 sm:p-10 mx-auto text-neutral-800 dark:text-neutral-200 flex items-center justify-center">
        <div className="block rounded-lg bg-neutral-200 shadow-lg dark:bg-neutral-800 w-full max-w-md">
          <div className="md:px-8">
            <div className="mx-6 py-8">
              <div className="text-center">
                <img className="mx-auto w-40 mb-4" src={cfLogo} alt="logo" />
                <h3 className="mb-2">Admin Login</h3>
                <p className="text-sm text-gray-500">Please login with admin credentials</p>
              </div>

              <form className="mt-6" onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="block text-xs mb-1">Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-3 py-2 rounded border"
                    placeholder="admin email"
                    autoComplete="off"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-xs mb-1">Password</label>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full px-3 py-2 rounded border"
                    placeholder="admin password"
                    autoComplete="off"
                  />
                </div>

                {error && <p className="text-xs text-red-500 mb-3">{error}</p>}

                <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded">
                  {loading ? 'Logging in...' : 'Login'}
                </button>
              </form>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdminLogin;
